import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_FUND_MANAGERS_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_FUND_MANAGERS_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_FUND_MANAGERS_DETAIL_API_ID,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/fund-managers/${id}`,
    method: 'GET',
  })
);

export default apiCall;
